var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"width":"300px"},attrs:{"pa-0":"","mx-2":""}},_vm._l((_vm.items),function(item,i){return _c('div',{attrs:{"fluid":""}},[_c('v-btn',{class:{ actionButton: _vm.value == i },staticStyle:{"margin":"5px","width":"100%"},on:{"click":function($event){return _vm.select(i)}}},[_vm._v(" "+_vm._s(item.text)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }